import { isDefined } from "@omni/utils/helper.utils";
import { createContext, ReactNode, use } from "react";

type OrderButtonContextValue = {
    isDisabled?: boolean;
    onSubmit: () => void;
};

type OrderButtonContextProviderProps = {
    isDisabled?: boolean;
    onSubmit: () => void;
    children: ReactNode;
};

export const OrderButtonContext = createContext<
    OrderButtonContextValue | undefined
>(undefined);

export const OrderButtonContextProvider = ({
    isDisabled,
    onSubmit,
    children
}: OrderButtonContextProviderProps) => {
    return (
        <OrderButtonContext
            value={{
                isDisabled: isDisabled,
                onSubmit: onSubmit
            }}
        >
            {children}
        </OrderButtonContext>
    );
};

export const useOrderButtonContext = () => {
    const context = use<OrderButtonContextValue | undefined>(
        OrderButtonContext
    );

    if (!isDefined(context)) {
        throw new Error(`${OrderButtonContext.displayName} is undefined.`);
    }

    return context;
};
